function formatMoney(cents, format) {
  format = format || (window.themeMoneyFormat || '${{amount}}');
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var amount = (cents / 100).toFixed(2);
  var parts = amount.split('.');
  var amountNoDecimals = parts[0];
  var amountWithComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
  var amountNoDecimalsWithComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  switch (format.match(placeholderRegex)[1]) {
    case 'amount': value = amount; break;
    case 'amount_no_decimals': value = amountNoDecimals; break;
    case 'amount_with_comma_separator': value = amountWithComma; break;
    case 'amount_no_decimals_with_comma_separator': value = amountNoDecimalsWithComma; break;
    default: value = amount;
  }
  return format.replace(placeholderRegex, value);
}

document.addEventListener('DOMContentLoaded', function () {
  // Mobile navigation drawer
  (function () {
    var toggle = document.querySelector('.menu-toggle');
    var drawer = document.getElementById('mobile-nav');
    var overlay = document.querySelector('.mobile-nav-overlay');
    var closeBtn = document.querySelector('.mobile-nav-close');
    if (!toggle || !drawer || !overlay) return;

    function openMenu() {
      drawer.classList.add('is-open');
      overlay.classList.add('is-visible');
      document.body.classList.add('nav-open');
      toggle.setAttribute('aria-expanded', 'true');
      drawer.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(function () { drawer.classList.add('is-animating'); });
    }
    function closeMenu() {
      drawer.classList.remove('is-animating');
      overlay.classList.remove('is-visible');
      document.body.classList.remove('nav-open');
      toggle.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('aria-hidden', 'true');
      setTimeout(function () { drawer.classList.remove('is-open'); }, 300);
    }
    toggle.addEventListener('click', function () {
      if (drawer.classList.contains('is-open')) closeMenu(); else openMenu();
    });
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    overlay.addEventListener('click', closeMenu);
    drawer.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', closeMenu); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeMenu();
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 820 && drawer.classList.contains('is-open')) closeMenu();
    });
  })();

  // Product variant picker: keep hidden variant id select, price, and button in sync
  (function () {
    var form = document.querySelector('form[data-product-form]');
    if (!form) return;
    var variantsScript = form.querySelector('[data-product-variants]');
    var idSelect = form.querySelector('[data-product-variant-select]');
    var optionSelects = form.querySelectorAll('.product-option-select');
    if (!variantsScript || !idSelect) return;

    var variants;
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }

    var priceEl = document.querySelector('[data-product-price]');
    var comparePriceEl = document.querySelector('[data-compare-price]');
    var buyBtn = form.querySelector('[data-buy-btn]');
    var mobilePriceEl = document.querySelector('[data-mobile-price]');
    var mobileBtnEl = document.querySelector('.mobile-bar [data-mobile-add]');

    function findMatchingVariant() {
      if (!optionSelects.length) return variants[0];
      var selected = Array.prototype.map.call(optionSelects, function (s) { return s.value; });
      return variants.find(function (v) {
        var vOptions = [v.option1, v.option2, v.option3];
        return selected.every(function (val, i) { return vOptions[i] === val; });
      });
    }

    function updateForVariant(variant) {
      if (!variant) {
        [buyBtn, mobileBtnEl].forEach(function (btn) {
          if (!btn) return;
          btn.disabled = true;
          btn.textContent = 'Unavailable';
        });
        return;
      }
      idSelect.value = variant.id;

      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (mobilePriceEl) mobilePriceEl.textContent = formatMoney(variant.price);

      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }

      [buyBtn, mobileBtnEl].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = !variant.available;
        btn.textContent = variant.available
          ? (btn.dataset.availableText || 'Add to Cart')
          : (btn.dataset.soldOutText || 'Sold Out');
      });

      if (variant.featured_image && variant.featured_image.src) {
        var mainImg = document.querySelector('[data-main-image]');
        if (mainImg) mainImg.src = variant.featured_image.src;
      }
    }

    optionSelects.forEach(function (select) {
      select.addEventListener('change', function () {
        var variant = findMatchingVariant();
        updateForVariant(variant);
      });
    });
  })();

  // Fade-up scroll reveal
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) entry.target.classList.add('in');
    });
  }, { threshold: 0.15 });
  document.querySelectorAll('.fade-up').forEach(function (el) { observer.observe(el); });

  // Quantity selectors (works for any .qty-box on the page)
  document.querySelectorAll('.qty-box').forEach(function (box) {
    var input = box.querySelector('input, span');
    var buttons = box.querySelectorAll('button');
    if (buttons.length < 2 || !input) return;
    buttons[0].addEventListener('click', function () {
      var val = parseInt(input.value || input.textContent, 10) || 1;
      if (val > 1) val--;
      if (input.tagName === 'INPUT') input.value = val; else input.textContent = val;
    });
    buttons[1].addEventListener('click', function () {
      var val = parseInt(input.value || input.textContent, 10) || 1;
      val++;
      if (input.tagName === 'INPUT') input.value = val; else input.textContent = val;
    });
  });

  // Product gallery thumbnails
  document.querySelectorAll('.thumb-row img').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mainImg = document.querySelector('.product-media .main-image img');
      if (mainImg && thumb.dataset.full) {
        mainImg.src = thumb.dataset.full;
      }
      document.querySelectorAll('.thumb-row img').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });

  // Mobile sticky bar quantity sync + add to cart trigger main form
  var mobileBtn = document.querySelector('.mobile-bar [data-mobile-add]');
  if (mobileBtn) {
    mobileBtn.addEventListener('click', function () {
      var form = document.querySelector('form[data-product-form]');
      if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  }
});
